import { useRef, useEffect } from "react";
import { getDocumentActiveElement } from "../utils/focus.js";
const useReturnFocusOnUnmount = (ref) => {
  const previouslyFocusedElementRef = useRef(null);
  useEffect(() => {
    const activeElement = ref.current ? getDocumentActiveElement(ref.current) : null;
    if (activeElement instanceof HTMLElement) {
      previouslyFocusedElementRef.current = activeElement;
    }
    return () => {
      if (previouslyFocusedElementRef.current instanceof HTMLElement && document.contains(previouslyFocusedElementRef.current)) {
        previouslyFocusedElementRef.current.focus();
      }
    };
  }, []);
};
export {
  useReturnFocusOnUnmount
};
//# sourceMappingURL=useReturnFocusOnUnmount.js.map
